import axios from 'axios'
import {MessageBox, Notification} from 'element-ui'
import store from '@/store'
import {setToken, getToken} from '@/utils/auth'
import {baseURL} from "@/settings"
import {ifNotWx, isWx} from "./wxUtil";

const service = axios.create({
    baseURL,
    // withCredentials: true,
    timeout: 10000
})

service.interceptors.request.use(
    config => {
        if (!config.data) {
            config.data = {
                Openid: getToken(),
                Nickname: "网页版无法获取微信昵称",
                platform: "web"
            }
        } else {
            config.data.Openid = getToken()
            config.data.Nickname = "网页版无法获取微信昵称"
            config.data.platform = "web"
        }
        return config
    },
    error => {
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

service.interceptors.response.use(
    response => {
        const res = response.data
        if (!isWx()) {
            return res
        }


        if (res.setting.Openid) {
            setToken(res.setting.Openid)
        }

        if (res.status !== 200) {

            if (res.status === 500) {
                Notification({
                    message: res.message || '服务器错误',
                    type: 'error',
                    duration: 100 * 1000,
                    position: 'bottom-right'
                })
                return Promise.reject(new Error(res.message || 'Error'))
            }

        } else {
            if (res.message && (!store.state.silentMode || res.important)) {
                let type = 'success'
                let duration = res.important ? 10 * 1000 : 3 * 1000
                if (res.msg === 'warn') {
                    type = 'warning'
                }
                Notification({
                    message: res.message,
                    type,
                    duration,
                    position: 'bottom-right'
                })
            }
            return res
        }
        return res
    },
    error => {
        console.log('err' + error) // for debug
        Notification({
            message: error.message,
            type: '错误',
            duration: 5 * 1000,
            position: 'bottom-right'
        })
        return Promise.reject(error)
    }
)

export default service
